import { ButtonColor, ButtonSize, FCC, Icon, Label } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

export const SectionHeader = styled.div``;

export const ViewPageTitle = styled.div`
	font-size: 2.5rem;
	line-height: 2.5rem;
	padding-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const ViewPageSubtitle = styled.div`
	font-size: 1.15rem;
	color: ${({ theme }) => theme.colors.palette.grey[70]};
`;

export const ViewPageSection = styled.div``;

export const ViewPageSectionHeader = styled.div`
	font-size: 1.5rem;
	line-height: 1.5rem;
	border-bottom: 1px solid ${({ theme }) => theme.colors.palette.grey[20]};
	padding-bottom: ${({ theme }) => theme.spacing(2)};
	margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const ViewPageSectionBody = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${({ theme }) => theme.spacing(4)};
`;

export const ViewPageSectionItem = styled.section``;

const ViewPageSectionListItemStyles = css`
	font-weight: normal;
	display: flex;
	align-items: center;
	justify-content: start;
	text-align: start;
	text-transform: unset;
	width: 100%;
	${({ theme }) => theme.breakpoints.tablet} {
		min-width: 200px;
	}
	gap: ${({ theme }) => theme.spacing(3)};
	i {
		margin-left: auto;
		width: 18px;
		height: 18px;
		color: ${({ theme }) => theme.colors.palette.grey[70]};
	}
`;
export const ViewPageSectionListItemWrapper = styled.div`
	${ViewPageSectionListItemStyles}
`;

export const ViewPageSectionListItemButton = styled.button<{ $color: ButtonColor; $size: ButtonSize }>`
	${({ theme }) => theme.buttons.text.base};
	${({ $color, theme }) => theme.buttons.text.colors[$color].base};
	${({ $size, theme }) => ($size === "small" ? theme.buttons.text.small.base : "")};
	${ViewPageSectionListItemStyles}
`;

export const DrawerFormButtonContainer = styled.div`
	display: grid;
	justify-content: start;
	gap: ${({ theme }) => theme.spacing(1)};
`;

export const ValueWrapper = styled.span`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: start;
	gap: ${({ theme }) => theme.spacing(3)};
`;

export const ViewPageSectionListItem: FCC<{ onClick: () => void }> = ({ children, onClick }) => {
	return (
		<ViewPageSectionListItemButton $color="default" $size="default" onClick={onClick}>
			{children}
			<Icon $icon="caret" />
		</ViewPageSectionListItemButton>
	);
};

export const PrimaryLabel: FC<{ className?: string; title?: string }> = (props) => {
	const { t } = useTranslation();
	return (
		<Label size="small" color="primary" {...props}>
			{props.title || t("Primary")}
		</Label>
	);
};
